(console as any).stdlog = console.warn.bind(console);
global.warnList = [];
global.injectWarn = function () {
   console.warn = function () {
      global.warnList?.push(Array.from(arguments).join(' '));
      (console as any).stdlog.apply(console, arguments);
   }
}

global.stopInjectWarn = function () {
   console.warn = (console as any).stdlog;
}
